import { CommonModule, isPlatformBrowser } from '@angular/common';
import { Component, Inject, PLATFORM_ID, ViewChild  } from '@angular/core';
import { ButtonModule } from 'primeng/button';
import { TableModule, Table } from 'primeng/table';
import { RouterLink, Router } from '@angular/router';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { FormsModule } from '@angular/forms';

import { AuthService } from '../../../../services/auth.service';
import { PageTitleService } from '../../../../services/pagetitle.service';
import { TimesheetService } from '../../../../services/timesheet.service';
import { NotificationService } from '../../../../services/notification.service';
import { EncryptionService } from '../../../../services/encryption.service';
import { Base64UrlService } from '../../../../services/base64-url.service';
import { AdminService } from '../../../../services/admin.service';
import { HttpClient } from '@angular/common/http';

/*----Prime NG----*/
import { InputTextModule } from 'primeng/inputtext';
import { InputIconModule } from 'primeng/inputicon';
import { IconFieldModule } from 'primeng/iconfield';

@Component({
  selector: 'app-rep-order-list',
  standalone: true,
  imports: [CommonModule, TranslateModule, ButtonModule, TableModule, InputTextModule, InputIconModule, IconFieldModule, FormsModule],
  providers: [Base64UrlService],
  templateUrl: './rep-order-list.component.html',
  styleUrl: './rep-order-list.component.css'
})
export class RepOrderListComponent {
  @ViewChild('dt2') dt2: any;
  userName: any;
  lang: any;
  contractList: any;
  monthDropdown: any;
  yearDropdown: any;
  userCode: any;
  // These hold filtered data
  visibleData: any[] = [];
  totalCount: number = 0;
  monthList: number[] = [];
  selectedMonth: number | null = null;
  selectedYear: number | null = null;
  dashboard_msg: string | null = null;
  msgType: string | null = null;

  
  dropDowndate: any;
  branchDropdown: any[] = [];
  customerDropdown: any[] = [];
  selectedBranch: string = '-1';
  selectedCustomer: string = '-1';
  selectedSystemId: string = '-1';
  selectedSupplierId: string = '-1';
  selectedDate: string = '';
  weekEndingDate: string = '';
  displayByCompany: boolean = false;
  isVisible: boolean = true;

  constructor(private auth: AuthService, private translate: TranslateService, private ts: TimesheetService, private as: AdminService, private en: EncryptionService, private pageTitle: PageTitleService, private http: HttpClient, private ns: NotificationService, @Inject(PLATFORM_ID) private platformId: Object) {
    if (typeof window !== 'undefined' && typeof localStorage !== 'undefined') {

      this.lang = (localStorage.getItem('site_lang') ? localStorage.getItem('site_lang') : 'en');
      // console.log(this.lang)
      translate.use(this.lang);
    }
  }

  ngOnInit() {
    this.userName = this.auth.getName();
    this.userCode = this.auth.getCode();
    this.pageTitle.setTitle('menu.orderlist');
    if (isPlatformBrowser(this.platformId)) {
      this.selectedYear = new Date().getFullYear();
      this.selectedMonth = new Date().getMonth()+1;
      this.getYear();
      this.monthList = Array.from({ length: 12 }, (_, i) => i + 1);
      this.getAssociates();
    }
  }

  getYear() {
    this.ns.getYearList()
      .subscribe({
        next: (resYearList: any) => {
          this.yearDropdown = resYearList.data;
          this.searchContracts();
          // this.getAssociatesList('2025-07-01');
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();
			return;	
          }
        }
      });
  }

  getAssociates() {
    
    this.as.getBranches()
      .subscribe({
        next: (resBranchList: any) => {
          this.branchDropdown = resBranchList.data;
          // console.log(this.branchDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout(); 
			return	
          }
        }
      });
    
    this.as.getCustomers()
      .subscribe({
        next: (resCustmomersList: any) => {
          this.customerDropdown = resCustmomersList.data;
          // console.log(this.customerDropdown);
        },
        error: (err: any) => {
          if(err.status === 401) {
            this.auth.logout();   
			return	
          }
        }
      });

  }

  getContractList(filterObj: any) {
    const dateFormat = this.selectedYear + "-" + this.selectedMonth;
    // this.as.getContract(filterObj)
    this.as.getGroupContract(filterObj)
      .subscribe({
        next: (res: any) => {
          if (res.status) {
            // this.contractList = res.data.map((item: any) => {
            //   return {
            //     ...item,
            //     jobOrderIdOrg: item.jobOrderID,
            //     jobOrderID: Base64UrlService.encode(this.en.encryptionAES(item.jobOrderID.toString()))
            //   }
            //   // this.applyEncryption();
            // }); 
            
            this.contractList = res.data.map((supplier: any) => ({
              ...supplier,
              sectionDto: supplier.sectionDto.map((section: any) => ({
                ...section,
                jobOrderDtos: section.jobOrderDtos.map((job: any) => ({
                  ...job,
                  jobOrderIdOrg: job.jobOrderID,
                  jobOrderID: Base64UrlService.encode(
                    this.en.encryptionAES(job.jobOrderID.toString())
                  )
                }))
              }))
            }));
            this.totalCount = this.contractList.length;
            this.updateVisibleData();
          }
        },
        error: (err: any) => {
          console.log(err);
          if (err.status == 401) {
            this.auth.logout();
			return
          } else {

          }
        }
    })
  }

  getSupplierRowspan(supplier: any) {
    return supplier.sectionDto.reduce((sum: number, sec: any) => {
      return sum + sec.jobOrderDtos.length;
    }, 0);
  }

  getSectionRowspan(section: any) {
    return section.jobOrderDtos.length;
  }

  ngAfterViewInit(): void {
    // 
  }

  // fncCng(event: any, dateType: any) {
  //   // let dateFormat = this.getDateFromEvent(event);
  //   let date = event.target.value;
  //   if (dateType == 'year') {
  //     this.selectedYear = date;
  //   } else if (dateType == 'month') {
  //     this.selectedMonth = date;
  //   }
  //   this.searchContracts();
  // }

  searchContracts() {
    // console.log(this.selectedMonth) 
    // console.log(this.selectedYear) 
    const filters = {
      startDate: this.selectedYear + "-" + this.selectedMonth,      
      selectedCustomer: this.selectedCustomer,
      selectedSupplierId: this.selectedSupplierId,
      selectedBranch: this.selectedBranch
    }
    this.getContractList(filters);
  }

  clearAll() {
    this.selectedYear = new Date().getFullYear();
      this.selectedMonth = new Date().getMonth();
    this.selectedCustomer = '-1';
    this.selectedBranch = '-1';
    this.totalCount = 0;
    this.displayByCompany = true;
    this.searchContracts()
  }
  applyFilterGlobal($event: Event) {
    const input = $event.target as HTMLInputElement;
    this.dt2.filterGlobal(input.value, 'contains');
    // Table triggers onFilter after this
  }

  // Update filteredData whenever filter or pagination changes
  onFilter(event: any) {
    this.updateVisibleData();
  }

  onPage(event: any) {
    this.updateVisibleData(event);
  }

  onSort() {
    this.updateVisibleData();
  }

  updateVisibleData(event?: any) {
    const filtered = this.dt2.filteredValue ?? this.contractList??[];
    const start = event?.first ?? this.dt2.first ?? 0;
    const rows = event?.rows ?? this.dt2.rows ?? 3;
    const end = start + rows;
    this.visibleData = filtered.slice(start, end);
  }

  onGlobalFilter(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.dt2.filterGlobal(value, 'contains');
    setTimeout(() => {
    this.totalCount = this.dt2.filteredValue
      ? this.dt2.filteredValue.length
      : this.dt2.value.length; // fallback to total rows if no filter applied
  });
  }

  applyEncryption(dt: any) {
      dt.forEach((elm: any, ind: any) => {
        dt[ind].jobOrderID = Base64UrlService.encode(this.en.encryptionAES(elm.jobOrderID.toString()))
      });
      return dt;
  }

  reset() {
    this.dashboard_msg = null;
  }
}
